import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../validator/customValidators';
import {Address} from '../model/address.model';
import {AddressService} from '../../core/services/address.service';
import {IEditAddress} from '../model/interface/edit-address.model.interface';
import {EventBusService} from '../../core/services/event-bus.service';
import {DictionaryPosition} from '../model/dictionary.model';
import {IAddress} from '../model/interface/address.model.interface';

@Component({
  selector: 'app-address-info',
  templateUrl: './address-info.component.html',
  styleUrls: ['./address-info.component.css']
})
export class AddressInfoComponent implements OnInit {
  @Input() address: Address;
  @Input() label: string;
  @Output() eventDelete = new EventEmitter<IAddress>();
  addressForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private eventBusService: EventBusService,
              private addressService: AddressService) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    this.addressForm = this.formBuilder.group({
      id: [this.address.id, Validators.required],
      street: [this.address.street, Validators.required],
      estateNumber: [this.address.estateNumber, Validators.required],
      localNumber: [this.address.localNumber],
      city: [this.address.city, [Validators.required, CustomValidators.cityValidator]],
      postalCode: [this.address.postalCode, [Validators.required]]
    });
  }

  updateAddress() {
    const payload = this.getPayloadToUpdate();
    const request = this.createUpdateAddressRequest(payload);
    return this.defaultRequestHandler(request);
  }

  deleteAddress() {
    this.addressService.deleteAddress(this.address.id)
      .subscribe(() => {
        this.eventDelete.next(this.address);
        this.eventBusService.display(DictionaryPosition.OK);
      });
  }

  private getPayloadToUpdate(): IEditAddress {
    const formValue = this.addressForm.value;
    return {
      street: formValue.street,
      estateNumber: formValue.estateNumber,
      localNumber: formValue.localNumber,
      city: formValue.city,
      postalCode: formValue.postalCode
    };
  }

  private createUpdateAddressRequest(payload: IEditAddress) {
    return this.addressService.updateAddress(this.address.id, payload);
  }

  private defaultRequestHandler(request) {
    return  request.subscribe(() => this.eventBusService.display(DictionaryPosition.OK));
  }
}
